module.exports = __webpack_public_path__ + "static/media/cross-kat.b9bfa35e.jpg";